import React from 'react';
import { useAppStore } from '../../../../GlobalStore/GlobalStore';

interface VideoPlayerProps {
    src: string;
    previewUrl?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, previewUrl }) => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    return (
        <div
            className="relative max-w-[90vw] max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
        >
            {environment.includes('jetbrains') ? (
                <div className="flex items-center justify-center bg-black bg-opacity-50 text-white rounded-xl w-full h-full min-h-[300px]">
                    <p className="text-center p-4">
                        Video playback not available in this browser
                    </p>
                </div>
            ) : (
                <video
                    controls
                    poster={previewUrl}
                    className="max-w-full max-h-full rounded-xl"
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        width: '600px',
                        height: '300px',
                        objectFit: 'contain',
                        backgroundColor: 'black'
                    }}
                >
                    <source
                        src={src.startsWith('data:') || src.startsWith('http')
                            ? src
                            : `data:video/mp4;base64,${src}`}
                        type="video/mp4"
                    />
                    Your browser does not support the video tag.
                </video>
            )}
        </div>
    );
};

export default VideoPlayer;